<template>
  <div class="property-reviews">
    <PropertyReviewsHeader/>
    <PropertyReviewsList :reviews="reviewsShortList"/>
    <button v-if="propertyStore.reviewsInfo?.total > 3" :aria-label="$t('Show all reviews')" @click="isModalVisible = true" class="show-all-button">
      {{$t('Show all')}} {{propertyStore.reviewsInfo?.total}} {{$t('reviews')}}
    </button>
    <DialogCloseOutside
        v-model:visible="isModalVisible"
        :showHeader="false"
        position="right"
        :block-scroll="true"
        :modal="true"
        :draggable="false"
        class="reviews-modal-container custom-scrollbar"
    >

        <div class="flex pb-6">
          <span class="flex-1 text-title-1 fw-bold">{{$t('Reviews')}}</span>
          <button @click="isModalVisible = false">
            <span class="icon icon-close color-blue text-title-1"></span>
          </button>
        </div>
        <PropertyReviewsHeader/>
        <PropertyReviewsList :reviews="reviewsShortList"/>
    </DialogCloseOutside>
  </div>
</template>

<script setup lang="ts">

// https://dev.tripening.com/api/product/v1/hotels/1952/reviews?page=1&size=1

import {DialogCloseOutside} from "#components";
import {useAccountStore} from '~/store/account'
import {usePropertyStore} from '~/store/property'
import PropertyReviewsHeader from '~/components/PropertyReviews/PropertyReviewsHeader.vue'
import PropertyReviewsList from '~/components/PropertyReviews/PropertyReviewsList.vue'
import dayjs from '~/utils/dayjs'

const route = useRoute()
const propertyStore = usePropertyStore()

const slug = <string>route.params.hotelSlug
const propertyId = Number(slug.split('-')[0])
let isModalVisible = ref(false as boolean)
let reviewsShortList = ref([] as any[])

async function getReviews() {
  try {
    const api = useApi()

    const res:any = await api(`/api/product/v1/hotels/${propertyId}/reviews?page=1&size=3&sort_by=highest_date`, {
      method: 'GET',
    })

    res.reviews?.forEach((review: any) => {
      review.formattedDate = dayjs(review.dt_created).format('MMMM YYYY')
    })
    propertyStore.setReviewsInfo(res)
    reviewsShortList.value = res.reviews
  } catch (e) {
    console.error(e)
  }
}

onMounted(() => {
  getReviews()
})

</script>

<style lang="scss" scoped>
.property-reviews {
  .show-all-button {
    display: flex;
    gap: 4px;
    height: 44px;
    align-items: center;
    padding: 11px 18px;
    color: var(--blue);
    border: 2px solid var(--blue);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    margin-top: 12px;
    .icon {
      font-size: 20px;
    }
  }
}
:global(.reviews-modal-container) {
  width: 100%;
  max-width: 708px;
  border-radius: 0;
  height: 100%;
  max-height: 100%;
  padding: 24px;
  overflow-y: auto;
}
</style>
